export enum ERRORCODE {
  SUCCESS = '00000000',
  NO_REQUEST = '10020003',
  WRONG_APPROVAL_NUMBER = '10020002',
  EXPIRATION_APPROVAL_NUMBER = '10020004',
}

// 010011
export enum ERRORCODE_CANCEL_VERIFY {
  SUCCESS = '10010001',
  NO_JOIN_MEMBER = '10020001',
  ALREADY_REQUESTED = '10020005',
}

// 010007
export enum ERRORCODE_CANCEL {
  SUCCESS = '10010002',
}

// 010018
export enum ERRORCODE_REFUND_VERIFY {
  WRONG_SECURITY_NUMBER = '10020021', // 보안문자 n회 입력오류
  EXPIRATION_SECURITY_NUMBER = '10020019', // 보안문자 3회 입력오류
  TELECOM_ERROR = '10020013', //SKT 가입자 (고객센터 문의)
  SERVICE_USAGE_EXISTS = '10020014', // 서비스 이용이력 존재
  REFUND_REGISTERED = '10020016', // 환불 이력 존재
  NO_JOIN_MEMBER = '10020018', // 비가입자
  ALREADY_SENT = '10020017', // 3분이내 발송이력 존재
  NEED_SERVICE_CANCEL = '10020119', // 미해지 → 해지 페이지 안내
  CUSTOMER_CENTER_INQUIRY = '10020120', // 고객센터 문의
}

// 010019
export enum ERRORCODE_REFUND {
  TELECOM_ERROR = '10020011', //통신사 오류
  CANCEL = '10020015', //가입 당일 해지
  EXPIRATION_APPROVAL_NUMBER = '10020020', // 인증번호 3회 입력 오류
}
